var map = {
	"./layout-admin": 5758,
	"./layout-admin.vue": 5758,
	"./layout-default": 2060,
	"./layout-default.vue": 2060,
	"./layout-exterior": 3958,
	"./layout-exterior.vue": 3958,
	"./layout-hostadmin": 9602,
	"./layout-hostadmin.vue": 9602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1409;